"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledControlWrapper = void 0;
var _input = require("../../components/inputs/input/input.tokens");
var _globalTokens = require("../global-tokens");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var StyledControlWrapper = exports.StyledControlWrapper = _styledComponents.default.div.withConfig({
  displayName: "ControlWrapperstyled__StyledControlWrapper",
  componentId: "sc-rsmnzf-0"
})(["display:flex;align-items:center;gap:", ";box-sizing:border-box;height:", ";background-color:", ";border:", ";border-radius:", ";width:", ";&:has(input:focus){outline:2px solid ", ";outline-offset:", ";}"], _globalTokens.globalSpacing['200'], function (_ref) {
  var height = _ref.height;
  return _input.tokens.size.height[height];
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? _input.tokens.color.background.disabled : _input.tokens.color.background.default;
}, function (_ref3) {
  var hasError = _ref3.hasError;
  return hasError ? _input.tokens.border.error : _input.tokens.border.default;
}, _input.tokens.borderRadius, function (_ref4) {
  var width = _ref4.width;
  return _input.tokens.size.width[width];
}, function (props) {
  return props.theme.sys.color.border.focusring;
}, function (_ref5) {
  var hasError = _ref5.hasError;
  return hasError ? '-4px' : '-2px';
});